import {default as types} from '../constants';
import {default as DataService} from '../services/data';
import {default as redirect} from '../utils/redirect';
import {default as Config} from '../config';
import { reducer as notifReducer, actions as notifActions, Notifs } from 'redux-notifications';

const { notifSend } = notifActions;

export function checkProductionOverlap(date, hour, form) {
	return (dispatch, state) => {
		dispatch(checkProductionOverlapRequest());

		let states = state();

		return DataService.request(
			Config.apiUrl+'customer/check-production-overlap/' + date + ' ' +hour, 
			{ method: 'GET'}, 
			{}, 
			dispatch
		).then((response) => {
			if(response !== undefined)
			{
				dispatch(reciveProductionOverlap(response.overlap));

				return response
			}
		});
	};
}

export function clearProductionOverlap() {
	return (dispatch, state) => {
		dispatch(reciveProductionOverlap(0))
	};
}

export function checkProductionOverlapRequest() {
	return {
		type: types.CHECK_PRODUCTION_OVERLAP_REQUEST
	};
}

export function reciveProductionOverlap(overlap) {
	return {
		type: types.RECEIVE_PRODUCTION_OVERLAP,
		payload: {
			production_overlap: overlap
		}
	};
}

export function fetchCustomer() {
		return (dispatch, state) => {
			dispatch(fetchCustomerRequest());

			let states = state();

			return DataService.request(
				Config.apiUrl+'customer/get-data', 
				{ method: 'GET'}, 
				{}, 
				dispatch
			).then((response) => {
				if(response !== undefined)
				{
					dispatch(reciveCustomer(response.model));
					dispatch(formEdit());
				}
			});
		};
}

export function fetchCustomerRequest() {
	return {
		type: types.FETCH_CUSTOMER_REQUEST
	};
}

export function reciveCustomer(model) {
	return {
		type: types.RECEIVE_CUSTOMER,
		payload: {
			model: model
		}
	};
}

export function formEdit() { 
	return {
		type: types.UPDATE_CUSTOMER_FORM,
		payload: {
		}
	};
}

export function sendDataCustomer() {
	return {
		type: types.CUSTOMER_FORM_SAVE
	};
}

export function saveCustomerSuccess() {
	return {
		type: types.CUSTOMER_FORM_SAVE_SUCCESS
	};
}

export function changeUserName(name) {
	return {
		type: types.CHANGE_USER_NAME,
		payload: {
			name: name
		}
	};
}

export function save(form) {
		return function(dispatch) {
			dispatch(sendDataCustomer());

			return DataService.request(Config.apiUrl+'customer/update', { method: 'PUT'}, form.model, dispatch, form)
					.then(form.props.onSuccess)
					.then(form.setErrorsOnInputs)
					.then(function(response){
						dispatch(changeUserName(form.model.name));
						dispatch(saveCustomerSuccess());
						dispatch(notifSend({
							message: 'Dane zostały pomyślnie zapisane',
							kind: 'success',
							dismissAfter: 2000
						}));
					})
					.then(form.afterSend);
		};
}

export function fetchInvoices(query) {
		return (dispatch, state) => {
			dispatch(fetchInvoicesRequest());

			return DataService.request(Config.apiUrl+'customer/invoice?pageSize=' + query.pageSize + '&page='+query.page+'&skip=' + query.skip, 
				{ method: 'GET' }, 
				{}, 
				dispatch
			);
		};
}

export function fetchInvoicesRequest() {
	return {
		type: types.FETCH_CUSTOMER_INVOICES_REQUEST,
		payload: {
		}
	};
}

export function fetchOrders(query) {
		return (dispatch, state) => {
			dispatch(fetchOrdersRequest());

			return DataService.request(Config.apiUrl+'customer/order?pageSize=' + query.pageSize + '&page='+query.page+'&skip=' + query.skip, 
				{ method: 'GET' }, 
				{}, 
				dispatch
			);
		}
}

export function fetchOrdersRequest() {
	return {
		type: types.FETCH_CUSTOMER_ORDERS_REQUEST,
		payload: {
		}
	}
}

/*** CREATE ORDER ***/
export function createOrder(form) {
		return function(dispatch) {
			dispatch(sendDataNewOrder());

			var isDiscount = form.model.discount_code != undefined ? true : false;

			return DataService.request(Config.apiUrl+'customer/order-create', { method: 'PUT'}, form.model, dispatch, form)
					.then(form.setErrorsOnInputs)
					.then(form.onSuccess)
					.then(form.onError)
					.then(function(response){
						dispatch(saveOrderCreate());
						redirect(dispatch, 'customer/order');
						dispatch(notifSend({
							message: isDiscount ? 'Zlecenie z kodem rabatowym zostało pomyślnie dodane' : 'Zlecenie zostało pomyślnie dodane',
							kind: 'success',
							dismissAfter: 2000
						}));
					});
		};
}

export function formOrderCreate() { 
	return {
		type: types.CUSTOMER_ORDER_FORM_CREATE,
		payload: {
		}
	};
}

export function sendDataNewOrder() {
	return {
		type: types.CUSTOMER_ORDER_CREATE_SEND_FORM
	};
}

export function saveOrderCreate() {
	return {
		type: types.CUSTOMER_ORDER_CREATE_SAVE_SUCCESS
	};
}
/***/
/*** UPDATE ORDER ***/
export function fetchOrder() {
	return (dispatch, state) => {
		dispatch(fetchOrderRequest());

		let states = state();

		return DataService.request(
			Config.apiUrl+'customer/get-order/'+states.routing.locationBeforeTransitions.query.id, 
			{ method: 'GET'}, 
			{}, 
			dispatch
		).then((response) => {
			if(response !== undefined)
			{
				dispatch(reciveOrder(response.model, response.products));
				dispatch(formUpdateOrder());
			}
		});
	};
}
export function fetchOrderRequest() {
	return {
		type: types.CUSTOMER_ORDER_FETCH_ORDER
	};
}

export function reciveOrder(model, products) {
	return {
		type: types.CUSTOMER_ORDER_RECEIVE_ORDER,
		payload: {
			model: model,
			products: products
		}
	};
}

export function formUpdateOrder() { 
	return {
		type: types.CUSTOMER_ORDER_UPDATE_FORM,
		payload: {
		}
	};
}
export function updateOrder(form) {
	return function(dispatch, state) {
		dispatch(updateOrderRequest());

		let states = state();

		return DataService.request(Config.apiUrl+'customer/order-update/'+states.routing.locationBeforeTransitions.query.id, 
				{ method: 'PUT'}, form.model, dispatch, form)
				.then(form.setErrorsOnInputs)
				.then(form.onSuccess)
				.then(form.onError)
				.then(function(response){
					dispatch(orderUpdateSuccess());
					redirect(dispatch, 'customer/order');
					dispatch(notifSend({
						message: 'Zlecenie zostało pomyślnie edytowane',
						kind: 'success',
						dismissAfter: 2000
					}));
				});
	};
}
export function updateOrderRequest() {
	return {
		type: types.CUSTOMER_ORDER_UPDATE_REQUEST
	};
}

export function orderUpdateSuccess() {
	return {
		type: types.CUSTOMER_ORDER_UPDATE_SUCCESS
	};
}
/*** GET PRODUCTS ***/
export function fetchProdcutsRequest() {
	return {
		type: types.CUSTOMER_ORDER_FETCH_PRODUCTS_REQUEST,
		payload: {
		}
	};
}

export function fetchProducts(input) {
	return (dispatch, state) => {
		dispatch(fetchProdcutsRequest());

		return DataService.request(Config.apiUrl+'customer/products', { method: 'GET'}, {}, dispatch)
		.then((response) => {
			dispatch(reciveProducts(response));
		});
	};
}

export function reciveProducts(data) {
	return {
		type: types.CUSTOMER_ORDER_RECEIVE_PRODUCTS,
		payload: {
			products: data.products,
			discount_code: data.discount_code,
			lamination : data.lamination
		}
	};
}
/***/
/*** CHECK CODE ***/
export function fetchActiveCode() {
	return {
		type: types.CUSTOMER_ORDER_FETCH_ACTIVE_CODE,
		payload: {
		}
	};
}

export function activeCode(code) {
	return (dispatch, state) => {
		dispatch(fetchActiveCode());

		return DataService.request(Config.apiUrl+'customer/active-code/'+code, { method: 'GET'}, {}, dispatch)
		.then((response) => {
			dispatch(reciveActiveCode(response.is_active));
		});
	};
}

export function reciveActiveCode(active) {
	return {
		type: types.CUSTOMER_ORDER_RECEIVE_ACTIVE_CODE,
		payload: {
			active: active
		}
	};
}
/***/
/*** CHANGE PASSWORD ***/
export function savePassword(form) {
		return function(dispatch) {
			return DataService.request(Config.apiUrl+'customer/change-password', { method: 'PUT'}, form.model, dispatch, form)
					.then(form.props.onSuccess)
					.then(form.setErrorsOnInputs)
					.then(function(response){
						dispatch(savePasswordSuccess());
						dispatch(notifSend({
							message: 'Hasło zostało pomyślnie zmienione',
							kind: 'success',
							dismissAfter: 2000
						}));
					})
					.then(form.afterSend);
		};
}
export function savePasswordSuccess() {
	return {
		type: types.CUSTOMER_CHANGE_PASSWORD_SUCCESS
	};
}
/***/
/*** REGISTER CUSTOMER ***/
export function requestRegisterCustomer() {
	return {
		type: types.CUSTOMER_REGISTER_REQUEST
	};
}
export function registerCustomerSuccess() {
	return {
		type: types.CUSTOMER_REGISTER_SUCCESS
	};
}
export function register(form) {
	return function(dispatch) {
		dispatch(requestRegisterCustomer());

		return DataService.request(Config.apiUrl+'customer/register', { method: 'POST'}, form.model, dispatch, form)
				.then(form.setErrorsOnInputs)
				.then(function(response) {
					return form.props.onSuccess(response);
				})
				.then(function(response){
					dispatch(registerCustomerSuccess());
					dispatch(notifSend({
						message: 'Rejestracja przebiegła pomyślnie, proszę czekać na e-maila z hasłem',
						kind: 'success',
						dismissAfter: 2000
					}));
					window.clearTimeout();
					window.setTimeout(()=>{
						redirect(dispatch, 'login');
					}, 3000);
				});
	};
}

export function requestRegisterConfirmCustomer() {
	return {
		type: types.CUSTOMER_REGISTER_CONFIRM_REQUEST
	};
}
export function registerConfirmCustomerSuccess() {
	return {
		type: types.CUSTOMER_REGISTER_CONFIRM_SUCCESS
	};
}

export function confirmRegister() {
	return function(dispatch, state) {
		dispatch(requestRegisterConfirmCustomer());

		let states = state();

		return DataService.request(Config.apiUrl+'customer/confirm-register/'+states.routing.locationBeforeTransitions.query.hash, 
					{ method: 'PUT'}, 
					{},
					dispatch
				)
				.then(function(response){
					dispatch(registerConfirmCustomerSuccess());

					return response;
				});
	};
}
/***/


/** WEBPACK FOOTER **
 ** ./js/actions/customer.js
 **/